import { render, staticRenderFns } from "./ratings-stars.vue?vue&type=template&id=bdb8787c&"
import script from "./ratings-stars.vue?vue&type=script&lang=ts&"
export * from "./ratings-stars.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports